import React from 'react';
import UserProfileModal from './UserProfileModal';

const UserPreferencesModal = (props) => (
  <UserProfileModal {...props} mode="preferences" />
);

export default UserPreferencesModal;
